module.exports = __webpack_public_path__ + "img/guardian_taking_you_with_me.14f56463.png";